import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { socketEvents } from '@/services/config'
import { showNotification } from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: ['levels', 'screenIndentifier'],
  data() {
    return {
      columnDefs: [],
      loader: false,
      create: new Vue(),
      list: this.levels,
      visible: false,
      isUpdate: false,
      loading: false,
      redrawTable: false,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        rowDragManaged: true,
        suppressMoveWhenRowDragging: 'true',
        suppressContextMenu: true,
        stopEditingWhenGridLosesFocus: true,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          sortable: true,
          editable: false,
          menuTabs: [],
        },
      },
      frameworkComponents: null,
      width: '100%',
      height: '44rem',
      selectedLevel1RowKeys: [],
      selectedLevel1Rows: [],
      selectedLevel2RowKeys: [],
      selectedLevel2Rows: [],
      selectedLevel3RowKeys: [],
      selectedLevel3Rows: [],
      selectedLevel4RowKeys: [],
      selectedLevel4Rows: [],
      level1Data: [],
      level2Data: [],
      level3Data: [],
      level4Data: [],
      postSortLevel1: null,
      postSortLevel2: null,
      postSortLevel3: null,
      postSortLevel4: null,
      level1Api: null,
      level2Api: null,
      level3Api: null,
      level4Api: null,
      levelIds: [],
      modalWidth: '115rem',
      padding: '0px',
      isFromTileMoved: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
    window.addEventListener('resize', this.detectViewPortListener)
    this.postSortLevel1 = rowNodes => {
      const tiles = []
      for (let i = 0; i < rowNodes.length; i++) {
        tiles.push(rowNodes[i].data)
      }
      this.level1Data = [...tiles]
    }
    this.postSortLevel2 = rowNodes => {
      const tiles = []
      for (let i = 0; i < rowNodes.length; i++) {
        tiles.push(rowNodes[i].data)
      }
      this.level2Data = [...tiles]
    }
    this.postSortLevel3 = rowNodes => {
      const tiles = []
      for (let i = 0; i < rowNodes.length; i++) {
        tiles.push(rowNodes[i].data)
      }
      this.level3Data = [...tiles]
    }
    this.postSortLevel4 = rowNodes => {
      const tiles = []
      for (let i = 0; i < rowNodes.length; i++) {
        tiles.push(rowNodes[i].data)
      }
      this.level4Data = [...tiles]
    }
  },
  created() {
    this.visible = true
    this.loader = true
    const levelList = [...this.levels]
    this.levelIds = levelList.map(i => i.id)
  },
  mounted() {
    this.$root.$on('onMoveTiles', this.recievedMessage)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        toolTipRenderer: ToolTipRenderer,
      }
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          floatingFilter: false,
          filter: false,
          width: 5,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'Tile Name',
          field: 'tileName',
          headerTooltip: 'Tile Name',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          width: 300,
          wrapText: false,
          filter: 'customFilter',
          resizable: true,
          cellRenderer: 'toolTipRenderer',
        },
      ]
    },

    handleOk() {},

    handleCancel() {
      this.visible = false
      this.$emit('closeTile', false, this.isUpdate)
    },

    getData(params, level, data) {
      this.$notification.destroy()
      params.api.sizeColumnsToFit()
      const api = params.api
      switch (level) {
        case 'Level1':
          this.level1Api = api
          this.level1Data = data
          this.level1Api.setRowData(data)
          break
        case 'Level2':
          this.level2Api = api
          this.level2Data = data
          this.level2Api.setRowData(data)
          break
        case 'Level3':
          this.level3Api = api
          this.level3Data = data
          this.level3Api.setRowData(data)
          break
        case 'Level4':
          this.level4Api = api
          this.level4Data = data
          this.level4Api.setRowData(data)
          break

        default:
          break
      }
      this.loader = false

      if (this.levels && this.levels.length > 1) {
        this.createDropZone(this.levels.length)
      }
    },

    onRowSelected(event, level) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      switch (level) {
        case 'Level1':
          this.selectedLevel1RowKeys = selectedData
          this.selectedLevel1Rows = selectedNodes.map(node => node.data)
          break
        case 'Level2':
          this.selectedLevel2RowKeys = selectedData
          this.selectedLevel2Rows = selectedNodes.map(node => node.data)
          break
        case 'Level3':
          this.selectedLevel3RowKeys = selectedData
          this.selectedLevel3Rows = selectedNodes.map(node => node.data)
          break
        case 'Level4':
          this.selectedLevel4RowKeys = selectedData
          this.selectedLevel4Rows = selectedNodes.map(node => node.data)
          break

        default:
          break
      }
    },

    onSelectionChanged(event, level) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      switch (level) {
        case 'Level1':
          this.selectedLevel1RowKeys = selectedData
          this.selectedLevel1Rows = selectedNodes.map(node => node.data)
          break
        case 'Level2':
          this.selectedLevel2RowKeys = selectedData
          this.selectedLevel2Rows = selectedNodes.map(node => node.data)
          break
        case 'Level3':
          this.selectedLevel3RowKeys = selectedData
          this.selectedLevel3Rows = selectedNodes.map(node => node.data)
          break
        case 'Level4':
          this.selectedLevel4RowKeys = selectedData
          this.selectedLevel4Rows = selectedNodes.map(node => node.data)
          break

        default:
          break
      }
    },

    onRowDragEnd(e, level, record) {
      const request = []
      let data = []

      switch (level) {
        case 'Level1':
          data = this.level1Data
          break
        case 'Level2':
          data = this.level2Data
          break
        case 'Level3':
          data = this.level3Data
          break
        case 'Level4':
          data = this.level4Data
          break

        default:
          break
      }
      data.forEach((i, index) => {
        request.push({
          id: i.id,
          tileName: i.tileName,
          sequence: index + 1,
        })
      })
      if (request.length > 0) {
        this.loader = true
        this.reorder(request, level, record)
      } else {
        this.loader = false
      }
    },

    onRowDragLeave(e, level, record) {
      this.onRowDragEnd(e, level, record)
    },

    reorder(request, level, record) {
      let url
      switch (this.screenIndentifier) {
        case 'Project Actual Cost':
          url = projectAPIs.project.asset.actualCost.level.tile.update(
            this.$route.params.id,
            record.assetId,
            record.id,
          )
          break
      }
      instance
        .patch(url, request)
        .then(response => {
          switch (level) {
            case 'Level1':
              this.selectedLevel1RowKeys = []
              this.level1Api.deselectAll()
              break
            case 'Level2':
              this.selectedLevel2RowKeys = []
              this.level2Api.deselectAll()
              break
            case 'Level3':
              this.selectedLevel3RowKeys = []
              this.level3Api.deselectAll()
              break
            case 'Level4':
              this.selectedLevel4RowKeys = []
              this.level4Api.deselectAll()
              break

            default:
              break
          }
          if (!this.isFromTileMoved) {
            this.isFromTileMoved = false
            this.loader = false
          }
          this.isUpdate = true
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    createDropZone(count) {
      if (
        count === 4 &&
        this.level1Api &&
        this.level2Api &&
        this.level3Api &&
        this.level4Api
      ) {
        this.addGridDropZone('Level1', this.level1Api, [
          'level2Api',
          'level3Api',
          'level4Api',
        ])
        this.addGridDropZone('Level2', this.level2Api, [
          'level1Api',
          'level3Api',
          'level4Api',
        ])
        this.addGridDropZone('Level3', this.level3Api, [
          'level1Api',
          'level2Api',
          'level4Api',
        ])
        this.addGridDropZone('Level4', this.level4Api, [
          'level1Api',
          'level2Api',
          'level3Api',
        ])
      } else if (
        count === 3 &&
        this.level1Api &&
        this.level2Api &&
        this.level3Api
      ) {
        this.addGridDropZone('Level1', this.level1Api, [
          'level2Api',
          'level3Api',
        ])
        this.addGridDropZone('Level2', this.level2Api, [
          'level1Api',
          'level3Api',
        ])
        this.addGridDropZone('Level3', this.level3Api, [
          'level1Api',
          'level2Api',
        ])
      } else if (count === 2 && this.level1Api && this.level2Api) {
        this.addGridDropZone('Level1', this.level1Api, ['level2Api'])
        this.addGridDropZone('Level2', this.level2Api, ['level1Api'])
      }
    },

    addGridDropZone(level, api, list) {
      let levelId
      let request = []
      if (level === 'Level1') {
        list.forEach(element => {
          api.addRowDropZone(
            this[element].getRowDropZoneParams({
              onDragStop: params => {
                const nodes = params.nodes
                const isValid = this.checkMoveTile(nodes, element)
                if (isValid) {
                  request = []
                  switch (element) {
                    case 'level2Api':
                      levelId = this.levelIds[1]
                      break
                    case 'level3Api':
                      levelId = this.levelIds[2]
                      break
                    case 'level4Api':
                      levelId = this.levelIds[3]
                      break

                    default:
                      break
                  }
                  if (this.selectedLevel1RowKeys.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else if (nodes && nodes.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else {
                    nodes.forEach(function(node) {
                      node.setSelected(false)
                    })
                  }
                  const ids = nodes.map(i => i.data.id)
                  ids.forEach(element => {
                    request.push({
                      id: element,
                      levelId: levelId,
                    })
                  })
                  this.moveTile(request, level, this.levels[0], element, nodes)
                }
              },
            }),
          )
        })
      }
      if (level === 'Level2') {
        list.forEach(element => {
          api.addRowDropZone(
            this[element].getRowDropZoneParams({
              onDragStop: params => {
                const nodes = params.nodes
                const isValid = this.checkMoveTile(nodes, element)
                if (isValid) {
                  request = []
                  switch (element) {
                    case 'level1Api':
                      levelId = this.levelIds[0]
                      break
                    case 'level3Api':
                      levelId = this.levelIds[2]
                      break
                    case 'level4Api':
                      levelId = this.levelIds[3]
                      break

                    default:
                      break
                  }
                  if (this.selectedLevel1RowKeys.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else if (nodes && nodes.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else {
                    nodes.forEach(function(node) {
                      node.setSelected(false)
                    })
                  }
                  const ids = nodes.map(i => i.data.id)
                  ids.forEach(element => {
                    request.push({
                      id: element,
                      levelId: levelId,
                    })
                  })
                  this.moveTile(request, level, this.levels[1], element, nodes)
                }
              },
            }),
          )
        })
      }
      if (level === 'Level3') {
        list.forEach(element => {
          api.addRowDropZone(
            this[element].getRowDropZoneParams({
              onDragStop: params => {
                const nodes = params.nodes
                const isValid = this.checkMoveTile(nodes, element)
                if (isValid) {
                  request = []
                  switch (element) {
                    case 'level1Api':
                      levelId = this.levelIds[0]
                      break
                    case 'level2Api':
                      levelId = this.levelIds[1]
                      break
                    case 'level4Api':
                      levelId = this.levelIds[3]
                      break

                    default:
                      break
                  }
                  if (this.selectedLevel1RowKeys.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else if (nodes && nodes.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else {
                    nodes.forEach(function(node) {
                      node.setSelected(false)
                    })
                  }
                  const ids = nodes.map(i => i.data.id)
                  ids.forEach(element => {
                    request.push({
                      id: element,
                      levelId: levelId,
                    })
                  })
                  this.moveTile(request, level, this.levels[2], element, nodes)
                }
              },
            }),
          )
        })
      }
      if (level === 'Level4') {
        list.forEach(element => {
          api.addRowDropZone(
            this[element].getRowDropZoneParams({
              onDragStop: params => {
                const nodes = params.nodes
                const isValid = this.checkMoveTile(nodes, element)
                if (isValid) {
                  request = []
                  switch (element) {
                    case 'level1Api':
                      levelId = this.levelIds[0]
                      break
                    case 'level2Api':
                      levelId = this.levelIds[1]
                      break
                    case 'level3Api':
                      levelId = this.levelIds[2]
                      break

                    default:
                      break
                  }
                  if (this.selectedLevel1RowKeys.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else if (nodes && nodes.length > 0) {
                    api.applyTransaction({
                      remove: nodes.map(function(node) {
                        return node.data
                      }),
                    })
                  } else {
                    nodes.forEach(function(node) {
                      node.setSelected(false)
                    })
                  }
                  const ids = nodes.map(i => i.data.id)
                  ids.forEach(element => {
                    request.push({
                      id: element,
                      levelId: levelId,
                    })
                  })
                  this.moveTile(request, level, this.levels[3], element, nodes)
                }
              },
            }),
          )
        })
      }
    },

    moveTile(request, level, record, api, nodes) {
      let url
      switch (this.screenIndentifier) {
        case 'Project Actual Cost':
          url = projectAPIs.project.asset.actualCost.level.tile.moveTile(
            this.$route.params.id,
            record.assetId,
            record.id,
          )
          this.isFromTileMoved = true
          break
      }
      this.loader = true
      instance
        .post(url, request)
        .then(response => {
          this[api].applyTransaction({
            update: nodes.map(function(node) {
              node.data.levelId = request[0].levelId
              return node.data
            }),
          })
          switch (level) {
            case 'Level1':
              this.selectedLevel1RowKeys = []
              this.level1Api.deselectAll()
              break
            case 'Level2':
              this.selectedLevel2RowKeys = []
              this.level2Api.deselectAll()
              break
            case 'Level3':
              this.selectedLevel3RowKeys = []
              this.level3Api.deselectAll()
              break
            case 'Level4':
              this.selectedLevel4RowKeys = []
              this.level4Api.deselectAll()
              break

            default:
              break
          }
          this.isUpdate = true
        })
        .catch(err => {
          this.loader = false
          this[api].applyTransaction({
            remove: nodes.map(function(node) {
              return node.data
            }),
          })
          errorService(err)
        })
    },

    checkMoveTile(nodes, api) {
      const tile = nodes.find(i => i.data.isAdjustmentTile)
      if (tile && tile.data.isAdjustmentTile) {
        this[api].applyTransaction({
          remove: nodes.map(function(node) {
            return node.data
          }),
        })
        const msg = 'You can not move adjustment tile to another level.'
        this.showMessage(tile.data, msg)
        return false
      }
      const linkedTiles = nodes
        .filter(i => i.data.isLinked)
        .map(i => i.data.tileName)
      if (linkedTiles && linkedTiles.length > 0) {
        this[api].applyTransaction({
          remove: nodes.map(function(node) {
            return node.data
          }),
        })
        const msg = 'You can not move tile which is linked to another level.'
        this.showTileMessage(linkedTiles, msg)
        return false
      }
      const childTiles = []
      nodes.forEach(element => {
        const isChild = element.data.takeoffs.some(i => i.childTileId)
        if (isChild) {
          childTiles.push(element.data.tileName)
        }
      })
      if (childTiles.length > 0) {
        this[api].applyTransaction({
          remove: nodes.map(function(node) {
            return node.data
          }),
        })
        const msg = 'You can not move tiles which is linked to child level.'
        this.showTileMessage(childTiles, msg)
        return false
      }
      let data = []
      let levelId
      switch (api) {
        case 'level1Api':
          data = [...this.level1Data]
          levelId = this.levelIds[0]
          break
        case 'level2Api':
          data = [...this.level2Data]
          levelId = this.levelIds[1]
          break
        case 'level3Api':
          data = [...this.level3Data]
          levelId = this.levelIds[2]
          break
        case 'level4Api':
          data = [...this.level4Data]
          levelId = this.levelIds[3]
          break

        default:
          break
      }
      const tileNames = nodes.map(i => i.data.tileName.toLowerCase())
      data = data
        .filter(
          i =>
            i.levelId === levelId &&
            tileNames.includes(i.tileName.toLowerCase()),
        )
        .map(i => i.tileName)
      if (data && data.length > 0) {
        this[api].applyTransaction({
          remove: nodes.map(function(node) {
            return node.data
          }),
        })
        const msg = 'You can not move tiles which are already exists in level.'
        this.showTileMessage([...new Set(data)], msg)
        return false
      }
      return true
    },

    showMessage(tile, msg) {
      var self = this
      const h = this.$createElement
      this.$info({
        title: 'Move Tiles',
        content: h('div', {}, [
          h(
            'div',
            { attrs: { class: 'linked-takeoff-div' } },
            self.showAdjustmentTile(h, [tile]),
          ),
          h('p', { attrs: { class: 'warning-message' } }, msg),
        ]),
        onOk() {},
      })
    },

    showAdjustmentTile(h, data) {
      const row = []
      data.forEach(element => {
        row.push(
          h('p', { attrs: { class: 'linked-takeoff' } }, `${element.tileName}`),
        )
      })
      return row
    },

    showTileMessage(tiles, msg) {
      var self = this
      const h = this.$createElement
      this.$info({
        title: 'Move Tiles',
        content: h('div', {}, [
          h(
            'div',
            { attrs: { class: 'linked-takeoff-div' } },
            self.showLinkedTiles(h, tiles),
          ),
          h('p', { attrs: { class: 'warning-message' } }, msg),
        ]),
        onOk() {},
      })
    },

    showLinkedTiles(h, data) {
      const row = []
      data.forEach(element => {
        row.push(h('p', { attrs: { class: 'linked-takeoff' } }, `${element}`))
      })
      return row
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.modalWidth = '115rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.modalWidth = '100%'
        this.padding = '10px !important'
      } else {
        this.modalWidth = '115rem'
        this.padding = '0px !important'
      }
    },

    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.tileMoved) {
        this.loader = false
      }
      if (data.EventType === socketEvents.takeoffAdjustmentCostUpdated) {
        this.loader = false
        if (data.Status === 'ERROR') {
          showNotification(
            'error',
            'Socket',
            _.get(data, 'Result.Message', null),
          )
        }
      }
    },
  },
}
